import React from "react";
import {
  HOME_SECTIONS,
  TRANSLATION_SECTIONS,
  TRUST_BAR_IDS,
  FEATURE_IDS,
  STEP_IDS,
  ROLE_IDS,
  ABOUT_FEATURE_IDS,
  SOLUTIONS_SMART_IDS,
  SOLUTIONS_ALT_IDS,
  DEVICE_IDS,
  CONTACT_INFO_IDS,
  CONTACT_FIELD_IDS,
} from "../../constants";
import {
  SkeletonSectionCard,
  SkeletonStickyNav,
  SkeletonBilingualTableHeader,
  SkeletonBilingualRow,
  SkeletonBilingualImageRow,
  SkeletonRepeaterBlocks,
  SkeletonHeroBlock,
} from "./CmsSkeletonPrimitives";

export function CommonLabelsPageSkeleton() {
  return (
    <div className="cms-skeleton-page" aria-busy="true" aria-label="Loading common labels">
      {TRANSLATION_SECTIONS.map((section) => (
        <SkeletonSectionCard key={section.id} id={section.id}>
          <SkeletonBilingualTableHeader />
          {section.keys.map((field, index) =>
            field.kind === "imagePath" ? (
              <SkeletonBilingualImageRow key={field.key} />
            ) : (
              <SkeletonBilingualRow
                key={field.key}
                tall={!!field.multiline || index % 4 === 3}
              />
            )
          )}
        </SkeletonSectionCard>
      ))}
    </div>
  );
}

export function HomePageSkeleton() {
  return (
    <div className="cms-skeleton-page" aria-busy="true" aria-label="Loading home page">
      <SkeletonStickyNav count={HOME_SECTIONS.length} />
      <SkeletonSectionCard id="hero">
        <SkeletonHeroBlock />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="trustBar">
        <SkeletonBilingualRow />
        <SkeletonRepeaterBlocks count={TRUST_BAR_IDS.length} columns={2} />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="careChallenge">
        <SkeletonBilingualRow />
        <SkeletonBilingualRow tall />
        <SkeletonBilingualImageRow />
        <SkeletonBilingualRow />
        <SkeletonBilingualImageRow />
        <SkeletonBilingualRow />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="features">
        <SkeletonBilingualRow />
        <SkeletonBilingualImageRow />
        <SkeletonRepeaterBlocks count={FEATURE_IDS.length} columns={3} />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="howItWorks">
        <SkeletonBilingualRow />
        <SkeletonBilingualImageRow />
        <SkeletonBilingualImageRow />
        <SkeletonRepeaterBlocks count={STEP_IDS.length} columns={1} />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="roleExperience">
        <SkeletonBilingualRow />
        <SkeletonBilingualImageRow />
        <SkeletonRepeaterBlocks count={ROLE_IDS.length} columns={2} />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="security">
        <SkeletonBilingualRow />
        <SkeletonBilingualRow tall />
        <SkeletonRepeaterBlocks count={4} columns={2} />
        <SkeletonBilingualImageRow />
        <SkeletonBilingualRow />
        <SkeletonBilingualImageRow />
      </SkeletonSectionCard>
    </div>
  );
}

export function AboutPageSkeleton() {
  return (
    <div className="cms-skeleton-page" aria-busy="true" aria-label="Loading about page">
      <SkeletonSectionCard id="hero">
        <SkeletonHeroBlock />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="features">
        <SkeletonRepeaterBlocks count={ABOUT_FEATURE_IDS.length} columns={1} />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="programCta">
        <SkeletonBilingualRow />
        <SkeletonBilingualRow tall />
        <SkeletonBilingualImageRow />
        <SkeletonBilingualRow />
      </SkeletonSectionCard>
    </div>
  );
}

export function SolutionsPageSkeleton() {
  return (
    <div className="cms-skeleton-page" aria-busy="true" aria-label="Loading solutions page">
      <SkeletonSectionCard id="hero">
        <SkeletonHeroBlock />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="smartSolutions">
        <SkeletonBilingualRow />
        <SkeletonRepeaterBlocks count={SOLUTIONS_SMART_IDS.length} columns={2} />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="alternatingFeatures">
        <SkeletonRepeaterBlocks count={SOLUTIONS_ALT_IDS.length} columns={1} />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="integratedDevices">
        <SkeletonBilingualRow />
        <SkeletonRepeaterBlocks count={DEVICE_IDS.length} columns={2} />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="programCta">
        <SkeletonBilingualRow />
        <SkeletonBilingualRow tall />
        <SkeletonBilingualImageRow />
      </SkeletonSectionCard>
    </div>
  );
}

export function ContactPageSkeleton() {
  return (
    <div className="cms-skeleton-page" aria-busy="true" aria-label="Loading contact page">
      <SkeletonSectionCard id="hero">
        <SkeletonHeroBlock />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="infoCards">
        <SkeletonRepeaterBlocks count={CONTACT_INFO_IDS.length} columns={1} />
      </SkeletonSectionCard>
      <SkeletonSectionCard id="messageSection">
        <SkeletonBilingualRow />
        <SkeletonBilingualRow tall />
        <SkeletonRepeaterBlocks count={CONTACT_FIELD_IDS.length} columns={1} />
        <SkeletonBilingualRow />
      </SkeletonSectionCard>
    </div>
  );
}

export const CMS_PAGE_SKELETONS = {
  common: CommonLabelsPageSkeleton,
  home: HomePageSkeleton,
  about: AboutPageSkeleton,
  solutions: SolutionsPageSkeleton,
  contact: ContactPageSkeleton,
};
